<template>
  <div class="insurance-chosen-variant"
       ref="variantRef">
    <div class="insurance-chosen-variant__process">
      <h3 v-if="headerHeading?.title" class="insurance-chosen-variant__title">{{ headerHeading.title }}</h3>
      <p
        class="insurance-chosen-variant__subtitle"
        v-if="currentStep !== steps[0] && currentStep !== steps[1] && headerHeading?.subtitle"
      >{{ headerHeading.subtitle }}
      </p>
      <FormClientDetails
        v-show="currentStep === steps[0] || currentStep === steps[1]"
        class="insurance-chosen-variant__form"
        @inn-is-defined="() => changeStep(1)"
        @prev-step="() => changeStep(0)"
        @close="$emit('close')"
        @client-details-submit="onClientDetailsSubmit"
        @short-term-change="resultForm.isShortTerm = $event"
      />
      <FormPropertyDetails
        :policy-dates="policyDates"
        :is-short-term="!!resultForm.isShortTerm"
        :locked-start-date="lockedPolicyStartDate"
        v-show="currentStep === steps[2]"
        class="insurance-chosen-variant__form"
        @cancel-subscription="$emit('cancel-subscription')"
        @prev-step="currentStep = steps[1]"
        @form-submit="onPropertyDetailsSubmit"
        @change-type="handleChangeTypeCar"
        @count-cars="changeCountCars"
        :tariff="tariffData"
        :uniq-code="uniqCode"
        :prolongation-data="resultForm?.prolongationAgreement ?? {}"
        :inn="resultForm?.inn"
        @show-request-form="showRequestCallModal = true"
      />
      <FormResult
        :policy-dates="policyDates"
        :quote-loading="quoteLoading"
        v-show="currentStep === steps[3]"
        class="insurance-chosen-variant__form"
        :tariffs="tariffData"
        :new-tariffs="newTariffsData ?? []"
        :quote-status="quoteStatus"
        :count-cars="insuredCarCount"
        :is-short-term="!!resultForm.isShortTerm"
        :locked-start-date="lockedPolicyStartDate"
        @policy-period-change="policyPeriod = $event"
        :min-start-date-timestamp="minStartDateTimestamp"
        :prolongation-data="resultForm?.prolongationAgreement ?? {}"
        @prev-step="() => changeStep(2)"
        @result-submit="onResultSubmit"
      />

      <FormPayment
        class="insurance-chosen-variant__form"
        v-show="currentStep === steps[4]"
        :tariffs="tariffData"
        :count-cars="insuredCarCount"
        :file-src="fileSrc"
        :btns-disabled="paymentBtnsDisabled"
        @prev-step="() => changeStep(3)"
        @result-submit="onPaymentSubmit"
      />

    </div>

    <InsuranceTariffCardOptions
      v-if="tariffData"
      :class="'insurance-chosen-variant__card ' + (typeCar === 'multi' ? 'insurance-chosen-variant__card--thin' : '')"
      ui-type="descriptional"
      :tariff="tariffData"
      :new-tariffs="newTariffsData ?? []"
        :quote-status="quoteStatus"
      :count-cars="insuredCarCount"
      :type-car="typeCar"
      :is-short-term="!!resultForm.isShortTerm"
      :start-date="policyDates.police_date"
      :contract-term="policyPeriod.contractTerm"
      :end-date="resultForm.isShortTerm ? policyDates.end_police_date : policyPeriod.endDate"
      :is-final="currentStep === steps[4]"
      :show-final-sum="currentStep === steps[3]"
      :show-message-less-one-year="currentStep === steps[0]"
    />

    <ModalRequestCall
      v-if="showRequestCallModal"
      :title="'Заказать звонок'"
      :text="'Оставьте контактные данные и наши менеджеры свяжутся с Вами!'"
      :visible="showRequestCallModal"
      modal-width="719px"
      @close="closeRequestCallModal"
      @request-call-submit="requestCallSubmitHandler"
      :result-form="resultForm"
    />

    <ModalRequestCallSuccess
      title="Ваша заявка отправлена"
      :visible="showRequestCallSuccessModal"
      modal-width="719px"
      @close="closeRequestCallSuccessModal"
    />

    <ModalPolicyIssuanceError
      title="Произошла ошибка"
      :text="errorText"
      :visible="showErrorModal"
      modal-width="719px"
      @close="closeModalError"
    />

    <ModalBlockError
      title="Оформление полиса невозможно"
      text="Оформление полиса невозможно. Пожалуйста, обратитесь к своему куратору"
      :visible="showBlockError"
      modal-width="719px"
    />
  </div>
</template>

<script>
import {getKuv, getPolicyDayCount} from '@/api/routes/inn';
import {insuranceRulesState} from '@/utils/insurance-rules';
import {parse, isValid, format, addDays} from 'date-fns';
import InsuranceTariffCardOptions from '@/components/ui/InsuranceTariffCardOptions';
import FormClientDetails from '@/components/forms/FormClientDetails';
import FormResult from '@/components/forms/FormResult';
import FormPayment from '@/components/forms/FormPayment';
import FormPropertyDetails from '@/components/forms/FormPropertyDetails';
import ModalPolicyIssuanceError from '@/components/modals/ModalPolicyIssuanceError';
import ModalBlockError from '@/components/modals/ModalBlockError';
import {getNumbersFromString} from '@/utils/string-helpers';
import {payByAcquiring, saveWithoutPayment} from '@/api/routes/payment';
import {getRisks, getUniqCode, checkExcludeUtm} from '@/api/routes/options';
import Cookies from 'js-cookie';
import ModalRequestCall from '@/components/modals/ModalRequestCall';
import ModalRequestCallSuccess from '@/components/modals/ModalRequestCallSuccess';

export default {
  name: 'InsuranceChosenVariant',
  components: {
    InsuranceTariffCardOptions,
    FormClientDetails,
    FormPropertyDetails,
    ModalPolicyIssuanceError,
    ModalBlockError,
    FormResult,
    FormPayment,
    ModalRequestCall,
    ModalRequestCallSuccess,
  },
  async mounted() {
    this.tariffData = await getRisks();
    const uniqCode = await getUniqCode();
    if (uniqCode?.code) {
      this.uniqCode = uniqCode.code;
    }

    const salesChannel = !!this.$route.query['sales-channel'] ? this.$route.query['sales-channel'] : '';
    const mentor = !!this.$route.query['mentor'] ? this.$route.query['mentor'] : '';

    const utmSource = !!this.$route.query?.utm_source ? this.$route.query.utm_source : '';
    const utmCampaign = !!this.$route.query?.utm_campaign ? this.$route.query.utm_campaign : '';

    const excludeUtmList = [];

    if (salesChannel) {
      excludeUtmList.push(salesChannel);
    }

    if (mentor) {
      excludeUtmList.push(mentor);
    }

    if (utmSource) {
      excludeUtmList.push(utmSource);
    }

    if (utmCampaign) {
      excludeUtmList.push(utmCampaign);
    }

    if (excludeUtmList.length >= 1) {
      let resExclude = await checkExcludeUtm(excludeUtmList);

      if (!resExclude?.result) {
        this.showBlockError = true;
      }
    }
  },
  props: {},
  inject: ['setShowGlobalSpinner'],
  data() {
    return {
      steps: ['define-inn', 'client-details', 'property-details', 'sum-result', 'payment'],
      currentStep: 'define-inn',
      //currentStep: 'property-details',
      showSuccessModal: false,
      showBlockError: false,
      showErrorModal: false,
      resultForm: {isShortTerm: false},
      policyDates: {police_date: '', end_police_date: ''},
      policyPeriod: {startDate: '', endDate: '', contractTerm: '12 месяцев'},
      discountPercent: 0,
      errorText: 'При оформлении оплаты произошла ошибка. Попробуйте позже.',
      tariffData: [],
      newTariffsData: [],
      quoteLoading: false,
      quoteError: '',
      quotedRequestKey: '',
      quoteRequestId: 0,
      uniqCode: '',
      typeCar: 'single',
      countCars: 1,
      fileSrc: '',
      resultId: 0,
      showRequestCallModal: false,
      isRequestCall: false,
      showRequestCallSuccessModal: false,
      minStartDateTimestamp: 0,
      paymentBtnsDisabled: false,
    }
  },
  methods: {
    async refreshQuote() {
      const requestId = ++this.quoteRequestId;
      const key = this.quoteRequestKey;
      this.quoteError = '';
      if (!key) {
        this.quoteLoading = false;
        return false;
      }
      const params = this.quoteParams;
      this.quoteLoading = true;
      try {
        const quote = await getKuv(params.inn, params);
        if (requestId !== this.quoteRequestId || key !== this.quoteRequestKey) return false;
        this.newTariffsData = quote.tariffList;
        const premium = quote.tariffList.reduce((sum, tariff) => sum + Number(tariff.premium), 0);
        this.resultForm = {
          ...this.resultForm,
          kuv: quote.kuv,
          newTariffs: quote.tariffList,
          allSum: Math.round(premium * this.insuredCarCount * 100) / 100,
        };
        this.quotedRequestKey = key;
        return true;
      } catch (error) {
        if (requestId === this.quoteRequestId && key === this.quoteRequestKey) {
          this.quoteError = error.message || 'Не удалось получить тарифы. Повторите расчёт.';
        }
        return false;
      } finally {
        if (requestId === this.quoteRequestId) this.quoteLoading = false;
      }
    },
    closeModalError() {
      this.showErrorModal = false
    },
    async requestCallSubmitHandler(formCall) {
      let form = this.resultForm;
      form.phone_number = formCall.phone;
      form.management_name = formCall.fio;
      form.email = formCall.email;
      form.is_request = 'Y';

      this.convertMaskedFields(form);
      this.setNullToInvalidFields(form);

      this.setShowGlobalSpinner(true);

      const formData = new FormData();

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (key === 'cars') {
            formData.append(key, JSON.stringify(form[key]));
          } else {
            formData.append(key, form[key]);
          }
        }
      }

      if (form.files) {
        form.files.forEach(file => {
          formData.append('files[]', file.raw);  // file.raw содержит сам файл
        });
      }

      let response = {};

      try {
        response = await saveWithoutPayment(formData);

        if (response?.result_id) {
          this.closeRequestCallModal();
          this.showRequestCallModalSuccessHandler();
        } else {
          this.closeRequestCallModal();
          this.showErrorModal = true;
          this.errorText = response.message;
        }
      } catch (e) {
        this.closeRequestCallModal();
        this.showErrorModal = true;
        this.errorText = 'Не удалось рассчитать стоимость. Повторите попытку позже';
      }

      this.setShowGlobalSpinner(false);
    },
    showRequestCallModalSuccessHandler() {
      this.showRequestCallSuccessModal = true;
    },
    closeRequestCallSuccessModal() {
      this.showRequestCallSuccessModal = false
    },
    closeRequestCallModal() {
      this.isRequestCall = false;
      this.showRequestCallModal = false
    },
    changeStep(index) {
      this.currentStep = this.steps[index];
      this.$emit('change-step' , this.currentStep);
    },
    changeCountCars(value) {
      this.countCars = value;
    },
    handleChangeTypeCar(value) {
      this.typeCar = value;
    },
    onClientDetailsSubmit(form) {
      this.resultForm = {...this.resultForm, ...form};
      this.currentStep = this.steps[2];
      this.$emit('change-step' , this.currentStep);
    },
    async onResultSubmit(form) {
      await this.$nextTick();
      if (!await this.refreshQuote()) return;
      this.resultForm = {...this.resultForm, ...form};
      this.saveResult(this.resultForm);
    },
    onPaymentSubmit() {
      this.processPayment(this.resultForm);
    },
    onPropertyDetailsSubmit(form) {
      this.resultForm = {...this.resultForm, ...form};
      if (!!form?.newProlongAgreement?.id) {
        this.resultForm.isProlongation = true;
        this.resultForm.prolongationAgreement = form.newProlongAgreement;
        this.resultForm.prolongationNumber = form.newProlongAgreement.id;
      }

      this.newTariffsData = form?.newTariffs ?? [];
      this.currentStep = this.steps[3];
      this.$emit('change-step' , this.currentStep);
    },
    isOnlyNumbers(input) {
      const pattern = /^\d+$/;
      return pattern.test(input);
    },
    async saveResult(form) {
      form.utm_source = !!this.$route.query?.utm_source ? this.$route.query.utm_source : '';
      form.utm_medium = !!this.$route.query?.utm_medium ? this.$route.query.utm_medium : '';
      form.utm_campaign = !!this.$route.query?.utm_campaign ? this.$route.query.utm_campaign : '';
      form.curator_email = !!this.$route.query?.email ? this.$route.query.email : '';

      form.mentor = !!this.$route.query['mentor'] ? this.$route.query['mentor'] : '';
      form.sales_channel = !!this.$route.query['sales-channel'] ? this.$route.query['sales-channel'] : '';
      form.agent = !!this.$route.query['agent'] ? this.$route.query['agent'] : '';
      form.subagent = !!this.$route.query['sub-agent'] ? this.$route.query['sub-agent'] : '';

      if (!!form.sales_channel) {
        Cookies.set('osgop_channel_isn', form.sales_channel, { expires: 90 });
      } else {
        if (!!form.utm_source && this.isOnlyNumbers(form.utm_source)) {
          Cookies.set('osgop_channel_isn', form.utm_source, { expires: 90 });
        }
      }

      if (!!form.agent) {
        Cookies.set('osgop_employee_isn', form.agent, { expires: 90 });
      } else {
        if (!!form.utm_medium && this.isOnlyNumbers(form.utm_medium)) {
          Cookies.set('osgop_employee_isn', form.utm_medium, { expires: 90 });
        }
      }
      if (!!form.subagent) {
        Cookies.set('osgop_subemployee_isn', form.subagent, { expires: 90 });
      } else {
        if (!!form.utm_medium && this.isOnlyNumbers(form.utm_medium)) {
          Cookies.set('osgop_subemployee_isn', form.subagent, { expires: 90 });
        }
      }

      if (!!form.mentor) {
        Cookies.set('osgop_curator_isn', form.mentor, { expires: 90 });
      } else {
        if (!!form.utm_campaign && this.isOnlyNumbers(form.utm_campaign)) {
          Cookies.set('osgop_curator_isn', form.utm_campaign, { expires: 90 });
        }
      }

      if (!!form.curator_email) {
        Cookies.set('osgop_curator_email', form.curator_email, { expires: 90 });
      }

      if (!form.utm_source) {
        form.utm_source = Cookies.get('osgop_channel_isn') ?? '';
      }

      if (!form.utm_medium) {
        form.utm_medium = Cookies.get('osgop_employee_isn') ?? '';
      }

      if (!form.utm_campaign) {
        form.utm_campaign = Cookies.get('osgop_curator_isn') ?? '';
      }

      if (!form.curator_email) {
        form.curator_email = Cookies.get('osgop_curator_email') ?? '';
      }

      if (!form.sales_channel) {
        form.sales_channel = Cookies.get('osgop_channel_isn') ?? '';
      }

      if (!form.agent) {
        form.agent = Cookies.get('osgop_employee_isn') ?? '';
      }
      if (!form.subagent) {
        form.subagent = Cookies.get('osgop_subemployee_isn') ?? '';
      }

      if (!form.mentor) {
        form.mentor = Cookies.get('osgop_curator_email') ?? '';
      }

      form.pampadu_click_id = !!this.$route.query?.click_id ? this.$route.query.click_id : '';
      form.pampadu_sub_id = !!this.$route.query?.sub_id ? this.$route.query.sub_id : '';
      form.admitad_uid = !!this.$route.query?.admitad_uid ? this.$route.query.admitad_uid : '';
      form.utm_content = !!this.$route.query?.utm_content ? this.$route.query.utm_content : '';
      form.utm_term = !!this.$route.query?.utm_term ? this.$route.query.utm_term : '';

      form.result_id = this.resultId ?? '';
      this.convertMaskedFields(form);
      this.setNullToInvalidFields(form);

      this.setShowGlobalSpinner(true);

      const formData = new FormData();

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (
            key === 'cars'
            || key === 'prolongationAgreement'
          ) {
            formData.append(key, JSON.stringify(form[key]));
          } else {
            formData.append(key, form[key]);
          }
        }
      }

      form.files.forEach(file => {
        formData.append('files[]', file.raw);  // file.raw содержит сам файл
      });

      form.taxiFile.forEach(file => {
        formData.append('filesTaxi[]', file.raw);
      });

      let response = {};

      try {
        response = await saveWithoutPayment(formData);
        this.minStartDateTimestamp = 0;

        if (response?.result_id && response?.file_src) {
          this.resultId = response.result_id;
          this.fileSrc = response.file_src;
          this.currentStep = this.steps[4];
          this.$emit('change-step' , this.currentStep);
        } else if (
          response?.ajax_errors
          && response?.ajax_errors?.MESSAGE
          && response?.ajax_errors?.MIN_TIMESTAMP
        ) {
          this.showErrorModal = true;
          this.errorText = response.ajax_errors.MESSAGE;
          this.minStartDateTimestamp = Number(response.ajax_errors.MIN_TIMESTAMP);
        } else if (
          response?.ajax_errors
          && response?.ajax_errors?.MESSAGE
          && response?.ajax_errors?.TAXI_FILE_ERROR
        ) {
          this.showErrorModal = true;
          this.errorText = response.ajax_errors.MESSAGE;
        } else if (
          response?.ajax_errors
          && response?.ajax_errors?.MESSAGE
        ) {
          this.showErrorModal = true;
          this.errorText = response.ajax_errors.MESSAGE;
        } else {
          this.showErrorModal = true;
          this.errorText = response.message;
          this.currentStep = this.steps[3];
          this.$emit('change-step' , this.currentStep);
        }
      } catch (e) {
        this.showErrorModal = true;
        this.errorText = 'Не удалось рассчитать стоимость. Повторите попытку позже';
        this.currentStep = this.steps[3];
        this.$emit('change-step' , this.currentStep);
        this.setShowGlobalSpinner(false);
        return;
      }

      // выключаем спиннер
      this.setShowGlobalSpinner(false);
    },
    async processPayment(form) {
      form.result_id = this.resultId ?? '';
      this.convertMaskedFields(form);
      this.setNullToInvalidFields(form);

      this.setShowGlobalSpinner(true);
      this.paymentBtnsDisabled = true;

      const formData = new FormData();

      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (
            key === 'cars'
            || key === 'prolongationAgreement'
          ) {
            formData.append(key, JSON.stringify(form[key]));
          } else {
            formData.append(key, form[key]);
          }
        }
      }

      form.files.forEach(file => {
        formData.append('files[]', file.raw);  // file.raw содержит сам файл
      });

      form.taxiFile.forEach(file => {
        formData.append('filesTaxi[]', file.raw);
      });

      let response = await payByAcquiring(formData);
      response?.result && window.open(response.redirect, '_self');

      if (!response?.result) {
        // ошибка запроса на оплату
        this.showErrorModal = true;
        this.errorText = response.message;
      }

      // выключаем спиннер
      this.setShowGlobalSpinner(false);
      this.paymentBtnsDisabled = false;
    },

    convertMaskedFields(form) {
      form.phone_number = getNumbersFromString(form.phone_number);
      form.passport_number = getNumbersFromString(form.passport_number);
    },

    setNullToInvalidFields(form) {
      for (let key in form) {
        if (!form[key]) {
          form[key] = null;
        }
      }
    },

    scrollToTop() {
      if (this.$refs?.variantRef) {
        this.$refs.variantRef.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    },
  },
  computed: {
    insuredCarCount() {
      return this.typeCar === 'single' ? 1 : this.countCars;
    },
    quoteParams() {
      const dates = {startDate: this.policyDates.police_date, endDate: this.policyDates.end_police_date};
      const isShortTerm = !!this.resultForm.isShortTerm && !!dates.startDate && !!dates.endDate;
      return {
        inn: this.resultForm.inn,
        isShortTerm,
        startDate: isShortTerm ? dates.startDate : '',
        endDate: isShortTerm ? dates.endDate : '',
      };
    },
    quoteRequestKey() {
      if (![this.steps[2], this.steps[3]].includes(this.currentStep) || !this.quoteParams.inn) return '';
      if (this.quoteParams.isShortTerm && !getPolicyDayCount(this.quoteParams.startDate, this.quoteParams.endDate)) return '';
      return JSON.stringify([this.quoteParams, this.insuredCarCount]);
    },
    quoteStatus() {
      if (this.currentStep === this.steps[4]) return '';
      if (this.quoteError) return this.quoteError;
      if (this.quoteLoading) return 'Пересчитываем стоимость…';
      if (this.quoteRequestKey && this.quoteRequestKey !== this.quotedRequestKey) return 'Пересчитываем стоимость…';
      return '';
    },
    lockedPolicyStartDate() {
      if (!this.resultForm.isShortTerm || !this.resultForm.isProlongation) {
        return '';
      }
      const agreement = this.resultForm.prolongationAgreement;
      if (!agreement) {
        return '';
      }
      if (typeof agreement.dateEnd === 'string') {
        const date = parse(agreement.dateEnd, 'dd.MM.yyyy', new Date());
        if (isValid(date)) {
          return format(addDays(date, 1), 'dd.MM.yyyy');
        }
      }
      const timestamp = Number(agreement.dateEndTimestamp);
      if (Number.isFinite(timestamp) && timestamp > 0) {
        const date = new Date(timestamp * 1000);
        if (isValid(date)) {
          return format(addDays(date, 1), 'dd.MM.yyyy');
        }
      }
      return '';
    },
    headerHeading() {
      switch (this.steps.indexOf(this.currentStep)) {
        case 0:
          return {
            title: '',
            subtitle: 'Введите ИНН и Мы автоматически заполним ваши данные'
          };
        case 1:
          return {
            title: '',
            subtitle: 'Проверьте заполненные данные и внесите информацию в пустые поля'
          };
        case 2:
          return {
            title: 'Данные страхуемого имущества',
            subtitle: 'Укажите данные одного или нескольких автомобилей'
          };
        case 4:
          return {
            subtitle: 'Проект договора'
          }
      }
    }
  },
  beforeDestroy() {
    this.quoteRequestId++;
    insuranceRulesState.isShortTerm = false;
  },
  watch: {
    quoteRequestKey() {
      this.refreshQuote();
    },
    'resultForm.isShortTerm': {
      immediate: true,
      handler(value) {
        insuranceRulesState.isShortTerm = !!value;
        this.policyDates.end_police_date = '';
      },
    },
    currentStep() {
      this.scrollToTop()
    }
  }
}
</script>

<style scoped lang="scss">
.insurance-chosen-variant {
  display: flex;

  @media #{$screen-medium} {
    flex-direction: column;
  }

  &__process {
    flex-grow: 1;
  }

  &__title {
    @include text-large($font-weight-semibold);

    @media #{$screen-big} {
      font-size: rem($font-size-medium);
    }
  }

  &__subtitle {
    @include text-medium($font-weight-regular, $line-height-medium);

    font-family: $font-family-secondary;

    margin-top: rem($gap-normal);
    margin-bottom: rem($gap-medium);
    width: fit-content;

    color: $color-text-muted-low2;

    @media #{$screen-big} {
      font-size: rem($font-size-normal);
    }
  }

  &__form {

  }

  &__card {
    width: 46%;
    margin-left: rem($gap-large);
    transition: width 0.2s ease;

    &--thin {
      transition: width 0.2s ease;
      width: 30%;
    }

    @media #{$screen-medium} {
      width: 100%;

      margin-left: 0;
      margin-top: rem($gap-big);
    }
  }
}
</style>